import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import Portal from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Portal';
import { makeStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2, 0),
  },
  rootPaddingNone: {
    padding: 0,
  },
}));

/**
 * @deprecated use DialogTitle instead
 */
const DialogTitle = ({
  children,
  padding,
}) => {
  const { titleRef } = useModalContext();
  const classes = useStyles();

  return (
    <Portal container={titleRef.current}>
      <div className={classNames(classes.root, {
        [classes.rootPaddingNone]: padding === 'none',
      })}
      >
        {children}
      </div>
    </Portal>
  );
};

DialogTitle.defaultProps = {
  padding: 'default',
};

DialogTitle.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
  padding: PropTypes.oneOf(['none', 'default']),
};

export default DialogTitle;
